export default {
  causes: [
    "The DeSapp violates the apps inclusion and exclusion criteria",
    "The Link to the DeSapp is not correct",
    "The DeSapp is duplicated",
    "The owner of the DeSapp is not the real owner",
    "Some information about the app is wrong",
    "Other",
  ],
};
